import { render, staticRenderFns } from "./NotificationDataNotLoaded.vue?vue&type=template&id=65d46659&lang=pug"
import script from "./NotificationDataNotLoaded.vue?vue&type=script&lang=ts"
export * from "./NotificationDataNotLoaded.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports